
import { TENANT_API } from "../constants/api";
import { getHeaders, getUrl, optionsGet } from "./commonService";
import customAxios from "./customAxios";

export default class TenantService {

  getTenantService(tenantName:string) {
   
    const url = getUrl(TENANT_API.INFO);
    const headers =getHeaders(tenantName);
    const options:any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });


  }
}
